import { SparkTagDimensionSelection } from '../types/sparkTypes';

export interface TagPatternDisplayDimension {
  dimensionFqn: string;
  name: string;
  isOptional: boolean;
  isStrict: boolean;
  elements: TagPatternDisplayElement[];
}

export interface TagPatternDisplayElement {
  fqn: string;
  name: string;
  description?: string;
  thumbnailUrl?: string;
  isActive: boolean;
}

export const patternArrayToMap = (pattern: SparkTagDimensionSelection[] | null | undefined) => {
  const map = new Map<string, SparkTagDimensionSelection>();
  if (!pattern) {
    return map;
  }
  pattern.forEach((entry) => {
    map.set(entry.dimension_fqn, entry);
  });
  return map;
};

export const sanitizePatternWithConstraints = (
  pattern: SparkTagDimensionSelection[] | null | undefined,
  allowedDimensions?: Set<string>,
  allowedElementFqnsByDimension?: Map<string, Set<string>>
): SparkTagDimensionSelection[] | null => {
  if (!pattern) {
    return null;
  }

  const filtered: SparkTagDimensionSelection[] = [];

  for (const entry of pattern) {
    if (allowedDimensions && !allowedDimensions.has(entry.dimension_fqn)) {
      continue;
    }

    const allowedElements = allowedElementFqnsByDimension?.get(entry.dimension_fqn);
    const elementFqns = allowedElements
      ? entry.element_fqns.filter((fqn) => allowedElements.has(fqn))
      : entry.element_fqns;

    filtered.push({
      dimension_fqn: entry.dimension_fqn,
      element_fqns: elementFqns,
      is_optional: entry.is_optional,
      is_strict: entry.is_strict,
    });
  }

  return filtered;
};

export const validateStrictDimensions = (
  pattern: SparkTagDimensionSelection[] | null | undefined,
  strictDimensions: Set<string>
): boolean => {
  if (!pattern) {
    return strictDimensions.size === 0;
  }
  for (const entry of pattern) {
    if (strictDimensions.has(entry.dimension_fqn) && entry.element_fqns.length === 0) {
      return false;
    }
  }
  return true;
};

